<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!pack">
      <span class="loader"></span>
    </span>
    <package-form
      v-if="pack"
      :loading="loading"
      :packData="pack"
      :formErrors="formErrors"
      @packSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import PackageForm from "../partials/PackageForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { PackageForm },

  mixins: [alertLeave],

  props: {
    packageId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      pack: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("packages/get", this.packageId);
        this.pack = this.$store.getters["packages/package"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(pack) {
      this.loading = true;
      const packData = cloneDeep(pack);

      try {
        await this.$store.dispatch("packages/update", packData);
        this.$notify({
          type: "success",
          message: this.$t("PACKAGES.PACKAGE_UPDATED"),
        });
        const pack = await this.$store.getters["packages/package"];
        this.$emit("onViewPackage", pack, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
